import { Component, ElementRef, forwardRef, Renderer2, ViewChild, input, inject } from '@angular/core';
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { FormModelDirective } from "../../../abstractions/form-model.directive";

@Component({
    selector: 'form-checkbox',
    templateUrl: './form-checkbox.component.html',
    styleUrls: ['./form-checkbox.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormCheckboxComponent),
            multi: true
        }],
    standalone: false
})
export class FormCheckboxComponent extends FormModelDirective {
  private readonly renderer = inject(Renderer2);


  currentId: string = 'ch' + Math.random().toString(16).substring(2);

  readonly label = input<string>();

  readonly fieldId = input<string>(`ch` + Math.random().toString(16).substring(2));

  readonly name = input<string>();

  readonly disabled = input<boolean>(false);

  readonly indeterminate = input<boolean>(false);

  @ViewChild('checkboxElementRef', { static: true })
  elementRef!: ElementRef<HTMLInputElement>;

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef?.nativeElement, 'disabled', isDisabled);
  }

}
